import { render, staticRenderFns } from "./AssistantWidget.vue?vue&type=template&id=30cb1dba&scoped=true"
import script from "./AssistantWidget.vue?vue&type=script&lang=js"
export * from "./AssistantWidget.vue?vue&type=script&lang=js"
import style0 from "./AssistantWidget.vue?vue&type=style&index=0&id=30cb1dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb1dba",
  null
  
)

export default component.exports